import { PrintFooter } from "@/components/print/PrintFooter.tsx";
import { Box } from "@skailer-com/uikit";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface PrintDocumentProps {
  header?: ReactNode;
  footerLabel: string;
  children: ReactNode;
}

const SHEET =
  "mx-auto flex min-h-[1123px] w-[794px] flex-col bg-light px-14 pt-14 pb-10 shadow-[0_0_0_1px_rgba(0,0,0,.05),0_2px_5px_rgba(0,0,0,.08),0_4px_12px_rgba(0,0,0,.04)] print:min-h-0 print:w-full print:p-0 print:shadow-none";

function buildPrintPageCss(footerLabel: string, pageMarkerContent: string) {
  return `
@page {
  size: 210mm 297mm;
  margin: 18mm 16mm 20mm;
  @bottom-left {
    content: "${footerLabel}";
    background: url("/favicon.svg") no-repeat left center / 16px 16px;
    padding-left: 22px;
    font-family: "Inter", system-ui, sans-serif;
    font-size: 10px;
    color: #3f3f46;
    vertical-align: middle;
  }
  @bottom-right {
    content: ${pageMarkerContent};
    font-family: "Inter", system-ui, sans-serif;
    font-size: 10px;
    color: #3f3f46;
    vertical-align: middle;
  }
}
@media print {
  * {
    animation: none !important;
    transition: none !important;
  }
  .print-doc-screen-footer {
    display: none !important;
  }
}
`;
}

export function PrintDocument({ header, footerLabel, children }: PrintDocumentProps) {
  const { t } = useTranslation();

  const pageMarkerContent = `"${t("common:page_of", { page: "__P__", total: "__T__" })}"`
    .replace("__P__", `" counter(page) "`)
    .replace("__T__", `" counter(pages) "`);

  const screenPageMarker = t("common:page_of", { page: 1, total: 1 });

  return (
    <Box className={SHEET}>
      <style>{buildPrintPageCss(footerLabel, pageMarkerContent)}</style>
      {header}
      {children}
      <PrintFooter label={footerLabel} pageMarker={screenPageMarker} />
    </Box>
  );
}
